import { render, staticRenderFns } from "./isLoading.vue?vue&type=template&id=06b2cadd&scoped=true"
import script from "./isLoading.vue?vue&type=script&lang=js"
export * from "./isLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b2cadd",
  null
  
)

export default component.exports